// extracted by mini-css-extract-plugin
export default {"wrapper":"upperNavbar_wrapper__bBpDv","box":"upperNavbar_box__baH3j","right":"upperNavbar_right__HvBfU"};